import React from "react"
import PropTypes from "prop-types"
import MDBDataTable from "../../components/Common/MDBDataTable"
import { Row, Col, Card, CardBody } from "reactstrap"

import "../Shoppers/datatables.scss"

const PlatformList = React.memo(({ customers }) => {
  return (
    <React.Fragment>
      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>

              <MDBDataTable responsive bordered data={customers} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
})

PlatformList.propTypes = {
  customers: PropTypes.shape({
    columns: PropTypes.arrayOf(PropTypes.object),
    rows: PropTypes.arrayOf(PropTypes.object),
  })
}

export default PlatformList
